import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useLanguage } from "@/hooks/useLanguage";
import { MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import logo from "@/assets/logo.webp";

const ContactSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.1);
  const { t } = useLanguage();

  return (
    <section id="kontakti" className="py-16 sm:py-20 bg-surface-blue">
      <div className="container mx-auto px-4" ref={ref}>
        <h2
          className={`text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          {t("contact.title")}
        </h2>
        <div className="grid md:grid-cols-[1fr_1.5fr] gap-8 sm:gap-10 max-w-5xl mx-auto">
          {/* Contact info */}
          <div
            className={`transition-all duration-700 delay-200 ${
              isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" aria-hidden="true" />
                <div>
                  <p className="font-medium">Bajāru iela 44</p>
                  <p className="text-muted-foreground text-sm">Rīga, LV-1006</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" aria-hidden="true" />
                <a href="tel:+37167817777" className="hover:text-primary transition-colors">+371 67817777</a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" aria-hidden="true" />
                <a href="mailto:info@mj.lv" className="hover:text-primary transition-colors">info@mj.lv</a>
              </div>
            </div>

            <Link
              to="/kontakti"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-colors text-sm min-h-[48px]"
            >
              {t("spl.cta.quote")}
              <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </Link>

            <div className="mt-8 flex justify-center">
              <img src={logo} alt="MJ Partneri" width={156} height={112} className="h-20 sm:h-28 w-auto opacity-90" loading="lazy" />
            </div>
          </div>

          {/* Map */}
          <div
            className={`rounded-xl overflow-hidden shadow-lg transition-all duration-700 delay-300 aspect-[4/3] sm:aspect-[16/10] md:aspect-[4/3] ${
              isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <iframe
              title="MJ Partneri atrašanās vieta"
              src="https://maps.google.com/maps?q=Baj%C4%81ru+iela+44,+Vidzemes+priek%C5%A1pils%C4%93ta,+R%C4%ABga,+LV-1006&t=&z=16&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
